import type { ReactNode } from "react"
import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

const ROW_BASE_CLASS = "grid items-start gap-x-2 gap-y-0.5 py-2"

/**
 * Grid so the description lines up under the label instead of under the
 * leading mark, which read as broken alignment.
 */
export const VISIBILITY_OPTION_ROW_CLASS = cn(
	ROW_BASE_CLASS,
	"grid-cols-[auto_1fr_auto]",
)

// Pair with `isSelected={null}`: a check column that never fills leaves a
// gutter that reads as the row being off-center.
export const VISIBILITY_OPTION_ROW_NO_CHECK_CLASS = cn(
	ROW_BASE_CLASS,
	"grid-cols-[auto_1fr]",
)

/** Width for menus built from these rows, so they stay the same size. */
export const VISIBILITY_MENU_WIDTH_CLASS = "w-[276px]"

interface VisibilityOptionRowProps {
	mark: ReactNode
	label: string
	description: string
	/** `null` for menus that create rather than switch, so no row is ever checked. */
	isSelected: boolean | null
}

export const VisibilityOptionRow = ({
	mark,
	label,
	description,
	isSelected,
}: VisibilityOptionRowProps) => (
	<>
		<span className="flex h-5 items-center">{mark}</span>
		<span className="text-sm font-medium text-primary">{label}</span>
		{isSelected !== null && (
			<span className="flex h-5 items-center">
				{isSelected && <Check className="h-4 w-4 flex-none" />}
			</span>
		)}
		<span
			className={cn(
				"col-start-2 text-xs leading-snug text-tertiary",
				isSelected !== null && "col-span-2",
			)}
		>
			{description}
		</span>
	</>
)
